var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FDB717",
    width: 32,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.99733 4s-4.19396 3.32297-7.79403 10.29627c2.17019-5.1272 2.02785-8.72672 2.02785-8.72672s-3.043 2.41263-5.686 7.47407c1.53868-3.71536 1.43643-6.30811 1.43643-6.30811s-2.2111 1.74893-4.15714 5.41122c1.08959-2.69066 1.01679-4.55918 1.01679-4.55918s-1.90597 1.50976-3.41848 4.68699c-1.5125 3.17722-1.4217 5.48222-1.4217 5.48222s1.54358-1.22425 2.95466-3.78486c-1.60495 3.79757-1.50024 6.46282-1.50024 6.46282s2.14483-1.70184 4.07289-5.26622c-2.24627 5.22138-2.10066 8.9016-2.10066 8.9016s2.97593-2.35806 5.60175-7.30215C12.9022 23.93035 13.1026 29 13.1026 29s4.68558-3.71237 8.40345-11.525C25.2239 9.66234 24.99733 4 24.99733 4z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/favicon.svg";
export { SvgFavicon as ReactComponent };